export enum LMSCourseTypes {
    BachelorsDegree = 0,
    MastersDegree = 1,
    AdditionalEducation = 2,
    ChildrensSchool = 3,
    Portfolio = 4,
    OnlineBachelorsDegre = 5,
    PrivateCourse = 6
}

export enum LMSCourseDurationTypes {
    long = 0,
    short = 1
}

export enum LMSCardFormatTypes {
    short = 0,
    long = 1,
}

export const LMS_COURSE_OPTIONS = [
    {
        label: 'бакалавриат',
        value: LMSCourseTypes.BachelorsDegree
    },
    {
        label: 'магистратура',
        value: LMSCourseTypes.MastersDegree
    },
    {
        label: 'онлайн-бакалавриат',
        value: LMSCourseTypes.OnlineBachelorsDegre
    },
    {
        label: 'дополнительное образование',
        value: LMSCourseTypes.AdditionalEducation
    },
    {
        label: 'детская школа',
        value: LMSCourseTypes.ChildrensSchool
    },
    {
        label: 'портфолио',
        value: LMSCourseTypes.Portfolio
    },
    {
        label: 'частный курс',
        value: LMSCourseTypes.PrivateCourse
    }
]

export const LMS_DURATION_OPTIONS = [
    {
        label: 'длинный',
        value: LMSCourseDurationTypes.long
    },
    {
        label: 'короткий',
        value: LMSCourseDurationTypes.short
    },
]
export const LMS_CARDFORMAT_OPTIONS = [
    {
        label: 'широкая',
        value: LMSCardFormatTypes.long
    },
    {
        label: 'узкая',
        value: LMSCardFormatTypes.short
    },
]

export enum LMSCourseTypes {
    BachelorsDegree = 0,
    MastersDegree = 1,
    AdditionalEducation = 2,
    ChildrensSchool = 3,
    Portfolio = 4,
    OnlineBachelorsDegre = 5,
    PrivateCourse = 6
}

export enum LMSCourseDurationTypes {
    long = 0,
    short = 1
}

export enum LMSCardFormatTypes {
    short = 0,
    long = 1,
}

export const LMS_COURSE_OPTIONS = [
    {
        label: 'бакалавриат',
        value: LMSCourseTypes.BachelorsDegree
    },
    {
        label: 'магистратура',
        value: LMSCourseTypes.MastersDegree
    },
    {
        label: 'онлайн-бакалавриат',
        value: LMSCourseTypes.OnlineBachelorsDegre
    },
    {
        label: 'дополнительное образование',
        value: LMSCourseTypes.AdditionalEducation
    },
    {
        label: 'детская школа',
        value: LMSCourseTypes.ChildrensSchool
    },
    {
        label: 'портфолио',
        value: LMSCourseTypes.Portfolio
    },
    {
        label: 'частный курс',
        value: LMSCourseTypes.PrivateCourse
    }
]

export const LMS_DURATION_OPTIONS = [
    {
        label: 'длинный',
        value: LMSCourseDurationTypes.long
    },
    {
        label: 'короткий',
        value: LMSCourseDurationTypes.short
    },
]
export const LMS_CARDFORMAT_OPTIONS = [
    {
        label: 'широкая',
        value: LMSCardFormatTypes.long
    },
    {
        label: 'узкая',
        value: LMSCardFormatTypes.short
    },
]

